<template>
  <el-dialog
    title="绑定录音风险配置"
    :visible.sync="dialogVisible"
    width="520px"
    append-to-body
    @open="onOpen"
    @close="onClose">
    <div v-loading="loading"
         class="asr-bind-dialog">
      <div class="asr-bind-dialog__meta">
        <div>分步模板：{{ rowTitle || '-' }}</div>
        <div>模板 ID：{{ substepId || '-' }}</div>
      </div>
      <el-form label-width="100px"
               size="medium">
        <el-form-item label="风险配置">
          <remote-select
            v-model="asrTemplateId"
            class="width-max"
            clearable
            keyword-key="title"
            label-key="title"
            value-key="id"
            placeholder="请选择录音风险配置"
            :query-request="queryAudioAsrCheckTemplateSelect"
            :find-request="getAudioAsrCheckTemplate"/>
        </el-form-item>
      </el-form>
      <div class="asr-bind-dialog__tip">
        一个分步模板最多绑定一个配置；清空并保存可解除绑定。
        <router-link v-if="viewConfigId"
                     :to="`/audio-asr-check/template/update/${viewConfigId}`"
                     target="_blank">查看配置
        </router-link>
      </div>
    </div>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary"
                 :loading="saving"
                 @click="onSubmit">保存
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'StepTemplateAsrBindDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    substepId: {
      type: [Number, String],
      default: null,
    },
    rowTitle: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      loading: false,
      saving: false,
      asrTemplateId: null,
      boundTemplateId: null,
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (value) {
        this.$emit('update:visible', value)
      },
    },
    viewConfigId () {
      const id = this.asrTemplateId || this.boundTemplateId
      return id && Number(id) > 0 ? id : null
    },
  },
  methods: {
    ...request.map([
      'queryAudioAsrCheckTemplateSelect',
      'getAudioAsrCheckTemplate',
      'getAudioAsrCheckBindBySubstep',
      'bindAudioAsrCheckTemplate',
      'unbindAudioAsrCheckTemplate',
    ]),
    onOpen () {
      this.loadBind()
    },
    onClose () {
      this.asrTemplateId = null
      this.boundTemplateId = null
    },
    loadBind () {
      if (!this.substepId) {
        return
      }
      this.loading = true
      request.common('getAudioAsrCheckBindBySubstep', { substepid: this.substepId }).then(({ data }) => {
        if (data && data.audio_asr_check_template_id) {
          this.asrTemplateId = Number(data.audio_asr_check_template_id)
          this.boundTemplateId = Number(data.audio_asr_check_template_id)
        } else {
          this.asrTemplateId = null
          this.boundTemplateId = null
        }
      }).finally(() => {
        this.loading = false
      })
    },
    onSubmit () {
      if (!this.substepId) {
        return
      }
      const nextId = this.asrTemplateId ? Number(this.asrTemplateId) : 0
      const currentId = this.boundTemplateId ? Number(this.boundTemplateId) : 0
      if (nextId === currentId) {
        this.dialogVisible = false
        return
      }

      this.saving = true
      const req = nextId
        ? request.common('bindAudioAsrCheckTemplate', {
          substepid: this.substepId,
          audio_asr_check_template_id: nextId,
        })
        : request.common('unbindAudioAsrCheckTemplate', this.substepId)

      req.then(() => {
        this.$message.success(nextId ? '绑定成功' : '已解除绑定')
        this.$emit('success')
        this.dialogVisible = false
      }).finally(() => {
        this.saving = false
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.asr-bind-dialog {
  &__meta {
    margin-bottom: 16px;
    color: #606266;
    font-size: 13px;
    line-height: 1.8;
  }

  &__tip {
    margin-top: 4px;
    color: #909399;
    font-size: 12px;
  }
}

.width-max {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/step-template/components/StepTemplateAsrBindDialog.vue